import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
   ListItemButton,
    Link,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import {
  Layers,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});
const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];
// Structure des données
const agriculturalData = {
  title: "Nombre de ménages agricoles par province selon la pratique agricole au cours des 12 derniers mois",
  columns: [
    "Province",
    "Irrigation",
    "Fertilisants minéraux",
    "Fumure organique",
    "Produits phyto-sanitaires",
    "Accès et utilisation des marais",
    "Aucun",
    "Total ménages agricoles"
  ],
  provinces: [
    {
      name: "BURUNDI",
      irrigation: "924 852",
      fertilisants: "1 590 618",
      fumure: "1 970 909",
      phytosanitaires: "838 118",
      marais: "977 245",
      aucun: "196 233",
      total: "2 335 995"
    },
    {
      name: "BUHUMUZA",
      irrigation: "168 536",
      fertilisants: "281 938",
      fumure: "358 519",
      phytosanitaires: "165 359",
      marais: "187 904",
      aucun: "24 062",
      total: "416 068"
    },
    {
      name: "BUJUMBURA",
      irrigation: "131 123",
      fertilisants: "231 682",
      fumure: "325 378",
      phytosanitaires: "205 492",
      marais: "72 023",
      aucun: "91 494",
      total: "461 754"
    },
    {
      name: "BURUNGA",
      irrigation: "157 050",
      fertilisants: "244 219",
      fumure: "324 374",
      phytosanitaires: "151 398",
      marais: "156 731",
      aucun: "40 147",
      total: "411 362"
    },
    {
      name: "BUTANYERERA",
      irrigation: "208 667",
      fertilisants: "380 401",
      fumure: "498 812",
      phytosanitaires: "171 382",
      marais: "264 000",
      aucun: "29 503",
      total: "552 250"
    },
    {
      name: "GITEGA",
      irrigation: "259 476",
      fertilisants: "452 378",
      fumure: "463 826",
      phytosanitaires: "144 487",
      marais: "296 587",
      aucun: "11 027",
      total: "494 561"
    }
  ]
};

const AgriculturalHouseholdsPages = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = agriculturalData.columns.join("\t") + "\n";
    
    agriculturalData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.irrigation}\t${province.fertilisants}\t${province.fumure}\t${province.phytosanitaires}\t${province.marais}\t${province.aucun}\t${province.total}\n`;
    });
    
    navigator.clipboard.writeText(`${agriculturalData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données sur les ménages agricoles du Burundi: ${agriculturalData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(agriculturalData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `menages-agricoles-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Calcul des indicateurs clés
  const keyStats = {
    totalHouseholds: agriculturalData.provinces[0].total,
    mostCommonPractice: (() => {
      const practices = [
        { name: "Fumure organique", value: agriculturalData.provinces[0].fumure },
        { name: "Fertilisants minéraux", value: agriculturalData.provinces[0].fertilisants },
        { name: "Irrigation", value: agriculturalData.provinces[0].irrigation },
        { name: "Accès aux marais", value: agriculturalData.provinces[0].marais },
        { name: "Produits phyto-sanitaires", value: agriculturalData.provinces[0].phytosanitaires }
      ];
      return practices.reduce((max, practice) => 
        parseInt(practice.value.replace(/\s/g, '')) > parseInt(max.value.replace(/\s/g, '')) ? practice : max
      );
    })(),
    highestIrrigation: agriculturalData.provinces.slice(1).reduce((max, province) => 
      parseInt(province.irrigation.replace(/\s/g, '')) > parseInt(max.irrigation.replace(/\s/g, '')) ? province : max
    ),
    lowestChemicalUse: agriculturalData.provinces.slice(1).reduce((min, province) => 
      parseInt(province.phytosanitaires.replace(/\s/g, '')) < parseInt(min.phytosanitaires.replace(/\s/g, '')) ? province : min
    ),
    highestOrganicUse: agriculturalData.provinces.slice(1).reduce((max, province) => 
      parseInt(province.fumure.replace(/\s/g, '')) > parseInt(max.fumure.replace(/\s/g, '')) ? province : max
    )
  };

  const filteredProvinces = agriculturalData.provinces.filter(province =>
    province.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

 
 
  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );



  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {agriculturalData.title}
                    </Typography>
                  </Box>
                    <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                        <Grid item xs={12} sm={6} md={6} ></Grid>
                        <Grid item xs={12} sm={6} md={6}>
                  <TextField
                      size="small"
                      placeholder="Rechercher province..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés des Pratiques Agricoles
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Agricoles Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.totalHouseholds}
                              </Typography>
                              <Typography variant="caption">
                                Au niveau national
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Pratique la plus courante
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostCommonPractice.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostCommonPractice.value}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte irrigation
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestIrrigation.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestIrrigation.irrigation}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte fumure organique
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestOrganicUse.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestOrganicUse.fumure}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des pratiques agricoles">
                      <StyledTableHead>
                        <TableRow>
                          {agriculturalData.columns.map((column, index) => (
                            <TableCell key={index} align={index > 0 ? "right" : "left"}>
                              {column}
                            </TableCell>
                          ))}
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredProvinces.map((province, index) => (
                          <ProvinceRow key={index} hover>
                            <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                              {province.name}
                            </TableCell>
                            <TableCell align="right">{province.irrigation}</TableCell>
                            <TableCell align="right">{province.fertilisants}</TableCell>
                            <TableCell align="right">{province.fumure}</TableCell>
                            <TableCell align="right">{province.phytosanitaires}</TableCell>
                            <TableCell align="right">{province.marais}</TableCell>
                            <TableCell align="right">{province.aucun}</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold' }}>{province.total}</TableCell>
                          </ProvinceRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                     {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des pratiques agricoles
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les différentes pratiques agricoles recensées:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Irrigation: Utilisation de systèmes d'arrosage pour les cultures" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Fertilisants minéraux: Utilisation d'engrais chimiques" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Fumure organique: Utilisation de compost ou fumier animal" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Produits phyto-sanitaires: Pesticides et herbicides" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Accès aux marais: Exploitation des zones maraîchères" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Les données montrent que {keyStats.mostCommonPractice.name} est la pratique la plus répandue 
                      avec {keyStats.mostCommonPractice.value} ménages l'utilisant, tandis que l'irrigation 
                      est moins courante avec {agriculturalData.provinces[0].irrigation} ménages.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, 
                    de l'Agriculture et de l'Elevage (RGPHAE) réalisé en 2024. Un ménage agricole est défini 
                    comme un ménage pratiquant au moins une activité agricole. Les chiffres représentent le 
                    nombre de ménages déclarant utiliser chaque pratique au cours des 12 derniers mois.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default AgriculturalHouseholdsPages;